"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryRoutes = void 0;
var CountryRoutes;
(function (CountryRoutes) {
    CountryRoutes["BasePrefix"] = "countries";
    CountryRoutes["ById"] = ":countryId";
    CountryRoutes["All"] = "all";
    CountryRoutes["List"] = "list";
})(CountryRoutes = exports.CountryRoutes || (exports.CountryRoutes = {}));
